import React, { useState, useEffect } from "react";
import config from "../../../../utils/config";
import styles from "./banList.module.css";
import { useFetch } from "../../../../hooks";
import { Table } from "@mantine/core";
import BanRow from "../../../common/banRow";

export const BanList = ({
  searchTerm,
  pageNumber,
  setTotalNumberOfBans,
  renderBanDetails,
  setCurrentBanDetails,
  setIsBanDetailVisible,
}) => {
  const [bannedRecords, setBannedRecords] = useState([]);

  const formattedSearchTerm = searchTerm.trim().toUpperCase();
  const url = `${
    config.BACKEND_HOST
  }/api/v1/bans/${formattedSearchTerm}?steamId=true&page=${pageNumber - 1}`;
  const { data: results, loading, error } = useFetch(url);

  useEffect(() => {
    if (!loading && results) {
      setTotalNumberOfBans(results.totalBans);
      setBannedRecords(results.bans);
    }
  }, [searchTerm, error, loading, results]);

  return (
    <div>
      <div className={styles.container}>
        <Table verticalSpacing="xs" striped highlightOnHover>
          <thead>
            <tr>
              <th>Banned ID</th>
              <th>Staff Member ID</th>
              <th>Ban Start</th>
              <th>Ban Length</th>
              <th>Ban Reason</th>
            </tr>
          </thead>
          <tbody>
            {bannedRecords.map((record, i) => {
              return (
                <BanRow
                  banInfo={record}
                  index={i}
                  viewDetails={renderBanDetails}
                  setCurrentBanDetails={setCurrentBanDetails}
                  setIsBanDetailVisible={setIsBanDetailVisible}
                />
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default BanList;
